'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _PageNumber = require('components/Pagination/PageNumber');

var _PageNumber2 = _interopRequireDefault(_PageNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Pagination.scss');

var Pagination = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(Pagination, _PureComponent);

  function Pagination() {
    (0, _classCallCheck3.default)(this, Pagination);
    return (0, _possibleConstructorReturn3.default)(this, (Pagination.__proto__ || (0, _getPrototypeOf2.default)(Pagination)).apply(this, arguments));
  }

  (0, _createClass3.default)(Pagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var checkMaxPage = nextProps.checkMaxPage,
          page = nextProps.page;

      if (checkMaxPage && page > 1) {
        var pagesCount = this.getPagesCount(nextProps);
        if (pagesCount < page) {
          this.changePage(pagesCount);
        }
      }
    }
  }, {
    key: 'getPagesCount',
    value: function getPagesCount() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
          count = _ref.count,
          limit = _ref.limit;

      return limit ? Math.ceil(count / limit) : 0;
    }
  }, {
    key: 'getPages',
    value: function getPages() {
      var _props = this.props,
          page = _props.page,
          showAroundCount = _props.showAroundCount,
          limit = _props.limit;

      if (!limit) {
        return null;
      }

      var pagesCount = this.getPagesCount();
      var start = [];
      var middle = [];
      var end = [];

      for (var i = page - showAroundCount; i <= page + showAroundCount; i++) {
        if (i > 0 && i <= pagesCount) {
          middle.push(i);
        }
      }

      if (middle[0] === 2) {
        middle.unshift(1);
      }

      if (middle[middle.length - 1] === pagesCount - 1) {
        middle.push(pagesCount);
      }

      if (middle[0] === 3) {
        middle = [1, 2].concat((0, _toConsumableArray3.default)(middle));
      } else if (middle[0] > 2) {
        start.push(1);
      }

      if ((0, _last3.default)(middle) === pagesCount - 2) {
        middle = [].concat((0, _toConsumableArray3.default)(middle), [pagesCount - 1, pagesCount]);
      } else if ((0, _last3.default)(middle) < pagesCount - 1) {
        end.push(pagesCount);
      }

      return { start: start, middle: middle, end: end };
    }
  }, {
    key: 'changePage',
    value: function changePage(newPage) {
      var _props2 = this.props,
          page = _props2.page,
          limit = _props2.limit,
          onChange = _props2.onChange;

      if (newPage === page) {
        return false;
      }

      var offset = newPage * limit - limit;

      onChange({ page: newPage, offset: offset, limit: limit });
    }
  }, {
    key: 'goNext',
    value: function goNext() {
      var page = this.props.page;

      var nextPage = page + 1;
      if (nextPage <= this.getPagesCount()) {
        this.changePage(nextPage);
      }
    }
  }, {
    key: 'goPrev',
    value: function goPrev() {
      var page = this.props.page;

      var prevPage = page - 1;
      if (prevPage >= 1) {
        this.changePage(prevPage);
      }
    }
  }, {
    key: 'renderPagesNumbers',
    value: function renderPagesNumbers(pages) {
      var _this2 = this;

      var page = this.props.page;

      return pages.map(function (pageNumber) {
        return _react2.default.createElement(_PageNumber2.default, {
          key: pageNumber,
          onClick: _this2.changePage,
          currentPage: page,
          pageNumber: pageNumber
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          limit = _props3.limit;

      var pagesCount = this.getPagesCount();
      var pages = this.getPages();
      var hidePagination = !limit || !pages || pagesCount < 2;
      if (hidePagination) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'span',
          { className: (0, _bind2.default)(styles.pageItem, styles.prevPage), onClick: this.goPrev },
          _react2.default.createElement('i', { className: 'icon-chevron-thin-left' })
        ),
        !!pages.start.length && _react2.default.createElement(
          'span',
          null,
          this.renderPagesNumbers(pages.start),
          _react2.default.createElement(
            'span',
            { className: styles.gap },
            '...'
          )
        ),
        this.renderPagesNumbers(pages.middle),
        !!pages.end.length && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'span',
            { className: styles.gap },
            '...'
          ),
          this.renderPagesNumbers(pages.end)
        ),
        _react2.default.createElement(
          'span',
          { className: (0, _bind2.default)(styles.pageItem, styles.nextPage), onClick: this.goNext },
          _react2.default.createElement('i', { className: 'icon-chevron-thin-right' })
        )
      );
    }
  }]);
  return Pagination;
}(_react.PureComponent), _class2.propTypes = {
  checkMaxPage: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  count: _propTypes2.default.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  limit: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  page: _propTypes2.default.number.isRequired,
  showAroundCount: _propTypes2.default.number
}, _class2.defaultProps = {
  showAroundCount: 2
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'changePage', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changePage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goNext', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'goNext'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goPrev', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'goPrev'), _class.prototype)), _class);
exports.default = Pagination;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/Pagination.js
// module id = 351
// module chunks = 1